import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportSubscriptionsDetailPage } from './report-subscriptions-detail.page';

const routes: Routes = [
  {
    path: '',
    component: ReportSubscriptionsDetailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportSubscriptionsDetailPageRoutingModule {}
